<div class="min-h-screen bg-gradient-to-br from-gray-50 via-white to-primary-50/40 print:min-h-0 print:bg-none print:bg-white">
  <app-sidebar />
  <div
    class="transition-all duration-200 print:!ml-0"
    [class.ml-64]="uiStore.sidebarOpen() && !uiStore.sidebarCollapsed()"
    [class.ml-16]="uiStore.sidebarOpen() && uiStore.sidebarCollapsed()"
    [class.ml-0]="!uiStore.sidebarOpen()">
    <app-header />
    <main class="p-6 print:p-[14mm]">
      @if (showFacilityGate()) {
        <app-no-facility-selected />
      } @else {
        <router-outlet />
      }
    </main>
  </div>
  @defer (when isChatEnabled()) {
    <app-chat-dock />
  }
  <app-toast />
</div>
